import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useOverlayContext } from 'seagull';
import { normalizeContactPhone } from '~/components/ContactForm/ContactForm.utils';
import { routes } from '~/constants';
import { useCreateClient, useCreateClientContact } from '~/hooks/reactQuery/queries/useClientMutations';
import { useApplyAccountingMapping } from '~/hooks/useApplyAccountingMapping';
import { useLocaleKeys } from '~/i18n';
import { ErrorResponse, errorTextsPath } from '~/infra/ErrorResponse';
export const CREATE_CONTACT_ERROR_TOAST_TEST_ID = 'create-client-contact-error-toast';
export const useCreateClientFlow = (dismissModal, onCreated)=>{
    const { createClient } = useCreateClient();
    const { createClientContact } = useCreateClientContact();
    const applyAccountingMapping = useApplyAccountingMapping();
    const { showErrorToast } = useOverlayContext();
    const history = useHistory();
    const { t: errorTexts } = useLocaleKeys(errorTextsPath);
    const [hasClientError, setHasClientError] = useState(false);
    const submit = useCallback(async (param)=>{
        let { clientType, name, contacts } = param;
        setHasClientError(false);
        let clientId;
        try {
            ({ clientId } = await createClient({
                name,
                clientType
            }));
        } catch (unused) {
            setHasClientError(true);
            return;
        }
        try {
            for (const contact of contacts){
                const { contactId, version } = await createClientContact({
                    clientId,
                    firstName: contact.firstName,
                    lastName: contact.lastName,
                    email: contact.email,
                    phone: normalizeContactPhone(contact.phone)
                });
                await applyAccountingMapping(contactId, version, contact.accounting, {});
            }
        } catch (error) {
            showErrorToast(new ErrorResponse(error).saveContactErrorText(errorTexts), CREATE_CONTACT_ERROR_TOAST_TEST_ID);
        }
        dismissModal();
        if (onCreated != null) {
            onCreated(clientId);
        } else {
            history.push(routes.client(clientId));
        }
    }, [
        createClient,
        createClientContact,
        applyAccountingMapping,
        showErrorToast,
        history,
        errorTexts,
        dismissModal,
        onCreated
    ]);
    return {
        submit,
        hasClientError
    };
};
